import clsx from 'clsx'
import {
  Root,
  List,
  Item,
  Trigger,
  Content,
  Viewport
} from '@radix-ui/react-navigation-menu'

/* blocks */
import Link from '@/atoms/Link/Link'
import { CategoriesDropdown } from './dropdowns'

/* utils */
import { HeaderProps as Props } from './Header.utils'

/* assets */
import { ReactComponent as PepperLogo } from 'public/assets/icons/PepperLogo_White.svg'
import { ReactComponent as DownIcon } from 'public/assets/icons/down.svg'

/* styling */
import styles from './desktop.module.css'

function DesktopHeader({
  showNavLinks,
  className,
  primaryCta,
  secondaryCta,
  tertiaryCta,
  mode,
  categoriesData
}: Props): JSX.Element {
  return (
    <nav
      className={clsx(
        className,
        mode === 'dark' ? 'bg-blue-web-90 text-white' : 'bg-white text-gray-80',
        'sticky top-0 left-0 | h-18 | z-50'
      )}
    >
      <div className="max-header-width | flex items-center justify-between | mx-auto px-6 | h-full">
        {showNavLinks ? (
          <Link href="/" className="z-1" title="Homepage">
            <PepperLogo className="h-8" />
          </Link>
        ) : (
          <PepperLogo className="h-8" />
        )}
        <div className="flex items-center gap-18">
          <Root
            className={clsx(
              'flex justify-center | h-full | ml-10',
              !showNavLinks && 'hidden!'
            )}
          >
            <List className="flex items-center gap-6">
              {/* Categories menu */}
              <Item>
                <Trigger className="focus-ring | flex items-center | py-6">
                  Pepper Blogs <DownIcon className="ml-1.5" />
                </Trigger>
                <Content className={styles.navDropdownContent}>
                  <CategoriesDropdown {...categoriesData} />
                </Content>
              </Item>

              {/* Resources link */}
              <Item>
                <Link
                  className="focus-ring | flex items-center | py-6"
                  href="/case-study/"
                >
                  Resources
                </Link>
              </Item>
            </List>

            <div className="absolute left-0 top-18 | w-screen">
              <Viewport className={clsx(styles.navViewport)} />
            </div>
          </Root>
        </div>

        <div className={clsx(!showNavLinks && 'hidden', 'flex items-center')}>
          {tertiaryCta ? (
            <Link
              href={tertiaryCta?.url}
              className={clsx(
                mode === 'dark' ? null : 'text-blue-50',
                'new-btn-neutral | max-h-8 | text-base font-medium | mr-3 px-4 py-1.5 | lg:hidden xl:inline-block'
              )}
            >
              {tertiaryCta.title}
            </Link>
          ) : null}

          {secondaryCta ? (
            <Link
              href={secondaryCta.url}
              className={clsx(
                mode === 'dark' ? null : 'bg-blue-20 text-blue-50',
                'new-btn-secondary | max-h-8 | text-base font-medium | mr-3 px-4 py-1.5 | lg:hidden xl:inline-block'
              )}
            >
              {secondaryCta.title}
            </Link>
          ) : null}
          {primaryCta ? (
            <Link
              href={primaryCta.url}
              className="new-btn-primary | max-h-8 | text-base font-medium | px-4 py-1.5"
            >
              {primaryCta.title}
            </Link>
          ) : null}
        </div>
      </div>
    </nav>
  )
}

export default DesktopHeader
